import { isOK } from "../../helpers/Utils";
import { MakeAuthHeader, PrimePoiApiRoot } from "../../config/api";
import axios from "axios";
import { TechnicianData } from "@primayer/poi-classes";

const state = {
  groupPois: [],
  loading: false,
  activeGroupPoi: null,
  groupsLoading: false,
};
const getters = {
  poi(state) {
    return state.poi;
  },
  groupPois(state) {
    return state.groupPois;
  },
  loading(state) {
    return state.loading;
  },
  activeGroupPoi(state) {
    return state.activeGroupPoi;
  }
};
const mutations = {
  setPoi(state, payload) {
    state.poi = payload;
  },
  setGroupPois(state, payload) {
    state.groupPois = payload;
  },
  removeGroupPoi(state, payload) {
    state.groupPois = state.groupPois.filter(l => l.id != payload.id);
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setActiveGroupPoi(state, payload) {
    const poi = state.groupPois.find(p => p.id == payload);
    if (poi) {
      state.activeGroupPoi = poi;
    }
  },
  updatePoiPauseState(state, payload) {
    if (state.activeGroupPoi) {
      state.activeGroupPoi.technicianData.paused = payload;
    }
  },
  updatePoiOnsiteState(state, payload) {
    if (state.activeGroupPoi) {
      state.activeGroupPoi.technicianData.onSiteTimes = [...payload];
    }
  },
  addComment(state, payload) {
    if (state.activeGroupPoi) {
      const commnets = [...state.activeGroupPoi.comments];
      state.activeGroupPoi.comments = [...commnets, payload];
    }
  },
  addImage(state, payload) {
    const images = [...state.activeGroupPoi.technicianData.photoURLs];
    state.activeGroupPoi.technicianData.photoURLs = [...images, payload];
  },
  removeImage(state, payload) {
    var images = [...state.activeGroupPoi.technicianData.photoURLs];
    images = images.filter(l => l != payload.content);
    state.activeGroupPoi.technicianData.photoURLs = [...images];
  },
  updateLeaks(state, payload) {
    if (state.activeGroupPoi) {
      const leaks = [...state.activeGroupPoi.technicianData.leaks];
      state.activeGroupPoi.technicianData.leaks = [...leaks, payload];
    }
  },
  updateTechnicianData(state, payload){
    if (state.activeGroupPoi) {
      state.activeGroupPoi.technicianData = payload;
    }
  }
};
const actions = {
  async GetPoisByGroups({ commit, rootGetters }, groupId) {
    const token = rootGetters["login/poiApiToken"];
    const url = `${PrimePoiApiRoot}poiCollection/GetPoisByGroupAndTechnician`;
    const technicianId = rootGetters["login/technicianId"];

    const options = {
      url: url,
      data: { technician: technicianId, groupId: groupId },
      headers: MakeAuthHeader(token),
      method: "POST"
    };
    const resp = await axios(options);
    if (isOK(resp)) {
      commit("setGroupPois", resp.data);
    } else {
      console.warn(resp);
    }
  },
  async PausePoi({ commit, rootGetters, state }, { isPause, logEntry }) {
    const token = rootGetters["login/poiApiToken"];
    const url = `${PrimePoiApiRoot}technician/UpdateSite`;
    const technicianId = rootGetters["login/technicianId"];
    const poiId = state.activeGroupPoi.id;

    const options = {
      url: url,
      data: {
        technician: technicianId,
        poiId: poiId,
        pause: isPause,
        logEntry: logEntry
      },
      headers: MakeAuthHeader(token),
      method: "PUT"
    };
    const resp = await axios(options);
    if (isOK(resp) && resp.data == true) {
      commit("updatePoiPauseState", isPause);
      return resp.data;
    } else {
      console.warn(resp);
    }
  },
  async onSitePoi({ commit, rootGetters, state }, { data, logEntry }) {
    const token = rootGetters["login/poiApiToken"];
    const url = `${PrimePoiApiRoot}technician/UpdateSite`;
    const technicianId = rootGetters["login/technicianId"];
    const poiId = state.activeGroupPoi.id;

    const options = {
      url: url,
      data: {
        technician: technicianId,
        poiId: poiId,
        onsite: true,
        logEntry: logEntry,
        onSiteTimes: data
      },
      headers: MakeAuthHeader(token),
      method: "PUT"
    };
    const resp = await axios(options);
    if (isOK(resp) && resp.data == true) {
      commit("updatePoiOnsiteState", data);
      return resp.data;
    } else {
      console.warn(resp);
    }
  },
  async AddCommentToPoi(
    { commit, rootGetters, state },commentObj ) {
    const token = rootGetters["login/poiApiToken"];
    const url = `${PrimePoiApiRoot}technician/AddCommentToPoi`;
    const technicianId = rootGetters["login/technicianId"];
    const poiId = state.activeGroupPoi.id;

    const options = {
      url: url,
      data: {
        technician: technicianId,
        poiId: poiId,
        isAddingComment: true,
        comment: commentObj
      },
      headers: MakeAuthHeader(token),
      method: "PUT"
    };
    const resp = await axios(options);
    if (isOK(resp) && resp.data == true) {
      commit("addComment", commentObj);
      return resp.data;
    } else {
      console.warn(resp);
    }
  },
  AddImageToPoi({ commit, rootGetters }, imageObj) {
    return new Promise(resolve => {
      const token = rootGetters["login/poiApiToken"];
      const url = `${PrimePoiApiRoot}technician/UploadImage`;
      imageObj.account = rootGetters["login/technicianId"];

      const options = {
        url: url,
        data: imageObj,
        headers: MakeAuthHeader(token),
        method: "POST"
      };
      axios(options)
        .then(resp => {
          commit("addImage", resp.data);
          resolve(resp.data);
        })
        .catch(error => {
          console.warn(error);
          resolve(false);
        });
    });
  },
  removeImageFromPoi({ commit, rootGetters }, imageObj) {
    return new Promise(resolve => {
      const token = rootGetters["login/poiApiToken"];
      const url = `${PrimePoiApiRoot}technician/RemoveImage`;
      imageObj.account = rootGetters["login/technicianId"];

      const options = {
        url: url,
        data: imageObj,
        headers: MakeAuthHeader(token),
        method: "DELETE"
      };
      axios(options)
        .then(resp => {
          commit("removeImage", imageObj);
          resolve(resp.data);
        })
        .catch(error => {
          console.warn(error);
          resolve(false);
        });
    });
  },
  async UpdatePoi({ rootGetters, state, commit }, technicianData) {
    const technicianId = rootGetters["login/technicianId"];
    const token = rootGetters["login/poiApiToken"];
    const poiId = state.activeGroupPoi.id;
    const data = {
      ...technicianData,
      technicianId: technicianId,
      poiId: poiId
    };

    const options = {
      url: `${PrimePoiApiRoot}technician/UpdateTechnician`,
      data: data,
      headers: MakeAuthHeader(token),
      method: "PUT"
    };

    const resp = await axios(options);
    commit("updateTechnicianData", resp.data);
    return resp.data;
  },
  async UploadPhoto({ rootGetters }, data) {
    const token = rootGetters["login/poiApiToken"];

    const options = {
      url: `${PrimePoiApiRoot}technician/UploadPhoto`,
      data: data,
      headers: MakeAuthHeader(token),
      method: "POST"
    };
    const resp = await axios(options);
    return resp;
  },
  AssignPoi({ commit, rootGetters }, poi) {
    return new Promise(resolve => {
      const token = rootGetters["login/poiApiToken"];
      const url = `${PrimePoiApiRoot}Router/TechnicianData?poiId=${poi.id}`;
      const techId = rootGetters["login/technicianId"];
      const techName = rootGetters["login/authUser"].username;
      var date = new Date();
      var techData = new TechnicianData(poi.technicianData);
      techData.technicianId = techId;
      techData.technicianname = techName;
      techData.completed = false;
      techData.escalate = false;
      techData.dateIssued = date;
      const options = {
        url: url,
        data: techData,
        headers: MakeAuthHeader(token),
        method: "PUT"
      };
      axios(options)
        .then(resp => {
          commit("group/removeGroupPoi", { group: poi.customerGroupId, poi: poi.id }, { root: true });
          resolve(true);
        })
        .catch(error => {
          console.warn(error);
          resolve(false);
        });
    });
  },
  UnassignPoi({ commit, rootGetters }, poi) {
    return new Promise(resolve => {
      const token = rootGetters["login/poiApiToken"];
      const url = `${PrimePoiApiRoot}Router/TechnicianData?poiId=${poi.id}`;
      var techData = new TechnicianData(poi.technicianData);
      techData.technicianId = null;
      techData.technicianName = "";
      techData.completed = false;
      techData.escalate = false;
      techData.dateIssued = null;
      const options = {
        url: url,
        data: techData,
        headers: MakeAuthHeader(token),
        method: "PUT"
      };
      axios(options)
        .then(resp => {
          commit("removeGroupPoi", poi);
          resolve(true);
        })
        .catch(error => {
          console.warn(error);
          resolve(false);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
